import React, { forwardRef, memo } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import PropTypes from 'prop-types';
import highchartsmore from 'highcharts/highcharts-more';
import solidgauge from 'highcharts/modules/solid-gauge';
highchartsmore(Highcharts);
solidgauge(Highcharts);

const LineChart = forwardRef((props, ref) => {
  const { options } = props;

  return (
    <div className="cyber-highchart-wrapper">
      <HighchartsReact
        ref={ref}
        highcharts={Highcharts}
        constructorType="chart"
        options={options}
      />
    </div>
  );
});
LineChart.propTypes = {
  options: PropTypes.object,
};

export default memo(LineChart);
